<template>
  <v-app>
    <div v-if="isTestEnv" class="watermark">測 試 資 料</div>

    <v-main :class="$store.state.isSerivceRouter ? '' : 'main-bg-img'">
      <router-view />

      <!-- snackbar -->
      <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" top>
        <v-icon small dark :color="snackbar.status" class="mr-2">
          {{
            snackbar.status === "success"
              ? "mdi-check-circle"
              : "mdi-alert-circle"
          }}
        </v-icon>
        {{ snackbar.content }}
        <template #action="{ attrs }">
          <v-btn
            small
            v-bind="attrs"
            color="primary"
            @click="snackbar.show = false"
          >
            {{ snackbar.close || "關閉" }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      serivces: {
        sms: process.env.VUE_APP_MAIN_SMS_BASE_URL,
        wt: process.env.VUE_APP_MAIN_WT_BASE_URL,
        aichat: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/listener",
      },
      snackbar: {
        show: false,
        content: "",
        status: "",
        timeout: 3000,
        close: "關閉",
      },
    };
  },
  created() {
    this.$root.$on("show-snackbar", (payload) => {
      this.snackbar = {
        ...payload,
        show: false,
      };
      this.$nextTick(() => {
        this.snackbar.show = true;
      });
    });
  },
  mounted() {},
  computed: {
    isTestEnv() {
      // 依據環境變數決定是否為測試環境
      return process.env.VUE_APP_PUBLIC_ENV === "preview";
    },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/styles.sass'


@media #{map-get($display-breakpoints, 'md-and-down')}
    .custom-class
        display: none
</style>

<style>
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%; /* 佔滿寬度 */
  height: 100%; /* 佔滿高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-30deg);
  font-size: 16vw; /* 使用 vw 單位，隨螢幕寬度縮放 */

  color: rgba(255, 0, 0, 0.15);
  pointer-events: none;
  z-index: 9999;
}

/* 針對不同裝置進行微調 */
@media (max-width: 768px) {
  .watermark {
    font-size: 20vw;
  }
}

@media (max-width: 480px) {
  .watermark {
    font-size: 21vw;
    font-weight: 700;
  }
}
</style>
